import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles, SelectField,
    TextField,
    useInputForm
} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {gridConstants, GridContainer, GridCell} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {isFimcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {aphLoanHistorySearchModel} from "./aphLoanHistorySearchFactory";
import {APH_LOAN_HISTORY_STATUS_LIST} from "../LoanManagement/aphLoanConstants";

interface AphLoanHistorySearchFormViewProps {
    aphLoanHistorySearchCriteria: Record<string, any>;
    aphLoanSearchDropDowns: Record<string, any>;
    handleSetAphLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
}

export const AphLoanHistorySearchFormView = ({
                                                 aphLoanHistorySearchCriteria,
                                                 aphLoanSearchDropDowns,
                                                 handleSetAphLoanHistorySearchCriteria,
                                                 isLoading,
                                             }: AphLoanHistorySearchFormViewProps) => {

    const patrons = createListFromArrayOfObjects(aphLoanSearchDropDowns?.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(aphLoanSearchDropDowns?.shippingLocations, "shippingLocationId", "name");
    const students = createListFromArrayOfObjects(aphLoanSearchDropDowns?.students, "studentId", "fullName");
    const districts = createListFromArrayOfObjects(aphLoanSearchDropDowns?.districts, "districtId", "districtName");
    const organizations = createListFromArray(aphLoanSearchDropDowns?.organizations);

    const aphLoanHistorySearchForm = useInputForm(aphLoanHistorySearchModel());

    const handleClearClick = () => {
        clearInputFormFields(aphLoanHistorySearchForm);
        const updatedLoanHistorySearchCriteria = {...aphLoanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.ClearLoanHistorySearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(aphLoanHistorySearchForm);
        const updatedLoanHistorySearchCriteria = {...aphLoanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.Search(criteria);
        handleSetAphLoanHistorySearchCriteria(updatedLoanHistorySearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.THREE,
    };

    return <>
        <InputForm name={"loanHistorySearch"} hasPaddingY>
            {
                isFimcAdmin() &&
                <SearchableSingleSelectField
                    {...aphLoanHistorySearchForm.patronId}
                    {...inputSharedSettings}
                    includeDefaultOption
                    label={'Patron'}
                    options={patrons}
                />
            }

            <TextField
                {...aphLoanHistorySearchForm.aphCatalogTitle}
                {...inputSharedSettings}
            />

            <SearchableSingleSelectField
                {...aphLoanHistorySearchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SearchableSingleSelectField
                {...aphLoanHistorySearchForm.studentId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Student'}
                options={students}
            />

            <SelectField
                {...aphLoanHistorySearchForm.aphLoanStatus}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"All"}
                includeDefaultOption
                label={"APH Loan Status"}
                options={APH_LOAN_HISTORY_STATUS_LIST}
            />

            {
                isFimcAdmin() &&
                <>
                    <SearchableSingleSelectField
                        {...aphLoanHistorySearchForm.districtId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label={'District'}
                        options={districts}
                    />
                    <SearchableSingleSelectField
                        {...aphLoanHistorySearchForm.organization}
                        {...inputSharedSettings}
                        includeDefaultOption
                        options={organizations}
                    />
                </>

            }

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>
                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>
};
